export default {
  NO_OFFERS: 'NO OFFERS',
  OFFERS_RECEIVED: 'OFFERS RECEIVED',
  SENT: 'SENT',
  RECEIVED: 'RECEIVED',
  NONE_SENT: 'NONE SENT',
  AWARDED: 'AWARDED',
  ACCEPTED: 'ACCEPTED',
  NONE_AWARDED: 'NONE AWARDED',
  AWARDED_ACCEPTED: 'AWARDED + ACCEPTED',
};
